import {IconApi, IconCloudOff, IconEye, IconForms} from '@tabler/icons-react';
import React from 'react';

import {ActionCard} from 'src/design/molecules/ActionCard';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {PageHeader} from 'src/design/organisms/PageHeader';
import {SidebarLinkTestArea} from 'src/app/layout/Sidebar/SidebarLinksConfig';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import {useAppNavigate} from 'src/shared/hooks/useAppNavigate';

export const TestAreaPage: React.FC = () => {
  const navigate = useAppNavigate();

  return (
    <ContentWrapper>
      <PageHeader>
        <PageHeader.Title
          icon={SidebarLinkTestArea.icon}
          subtitle="Development and testing tools">
          Test Area
        </PageHeader.Title>
      </PageHeader>
      <ActionCard title="Tools">
        <ActionCard.Action
          icon={<IconEye size={14} />}
          onClick={() => navigate(PathUtility.AdminViewTestForm())}>
          View Test Form
        </ActionCard.Action>
        <ActionCard.Action
          icon={<IconForms size={14} />}
          onClick={() => navigate(PathUtility.AdminEditTestForm())}>
          Edit Test Form
        </ActionCard.Action>
        <ActionCard.Action
          icon={<IconApi size={14} />}
          onClick={() => navigate(PathUtility.AdminTestApiInteractions())}>
          Test API Interactions
        </ActionCard.Action>
        <ActionCard.Action
          icon={<IconCloudOff size={14} />}
          onClick={() => navigate(PathUtility.AdminOfflineTest())}>
          Offline Test
        </ActionCard.Action>
      </ActionCard>
    </ContentWrapper>
  );
};

routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.AdminTestArea(),
  element: <TestAreaPage />,
  isPrivate: true,
  requireSuperAdmin: true,
});

export default TestAreaPage;
